import type { SxProps, Theme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";

export const root: SxProps<Theme> = (theme) => ({
  display: "flex",
  alignItems: "center",
  gap: { xs: theme.spacing(1.375), md: theme.spacing(2) },
  p: { xs: theme.spacing(1.625, 1.75), md: theme.spacing(2.5, 2.75) },
  borderRadius: { xs: 2, md: 2.5 },
  bgcolor: "background.paper",
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: { xs: theme.shadows[1], md: theme.shadows[2] },
  overflow: "hidden",
});

export const iconWrap =
  (accentColor: string): SxProps<Theme> =>
  () => ({
    width: { xs: 38, md: 48 },
    height: { xs: 38, md: 48 },
    borderRadius: { xs: 1.375, md: 1.75 },
    bgcolor: alpha(accentColor, 0.12),
    color: accentColor,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  });

export const valueBlock: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: 0.375,
  minWidth: 0,
};

export const value =
  (color?: string): SxProps<Theme> =>
  (theme) => ({
    fontSize: { xs: "1.1875rem", md: "1.625rem" },
    fontWeight: 800,
    lineHeight: 1.1,
    color: color ?? theme.palette.text.primary,
  });

export const label: SxProps<Theme> = {
  fontSize: { xs: "0.6875rem", md: "0.8125rem" },
  color: "text.secondary",
};
